<template>
  <base-widget title="Clients with Most Opens">
    <base-list
      :items="topOpens"
      :class="`mx-2 ${topOpens.length ? 'mt-n3' : ''}`"
      :show-reload="false"
      :loading="loading"
    >
      <template #loading>
        <base-skeleton
          v-for="n in 5"
          :key="`mostopens_skel_${n}`"
          :opacity="1/n"
          class="px-3 py-3 mx-n3 d-flex align-items-center"
        >
          <div
            class="skeleton__item py-2 mr-5"
            style="max-width: 150px"
          />
          <div class="d-flex w-100 justify-content-between pl-5">
            <div
              class="skeleton__item"
              style="max-width: 300px; margin-top: 0.5rem"
            />
            <div
              class="skeleton__item"
              style="max-width: 25px"
            />
          </div>
        </base-skeleton>
      </template>
      <template #default="{item, index}">
        <base-cell :class="`pt-3 ${index < topOpens.length - 1 ? 'pb-3' : 'mb-n2'}`">
          <div
            class="col-3 clickable"
            @click="goToClient(item.pk)"
          >
            <base-text
              class="black"
              size="m"
            >
              {{ item.first_name }} {{ item.last_name }}
            </base-text>
          </div>
          <div
            class="col-3 clickable"
            @click="goToClient(item.pk)"
          >
            <base-text
              class="black"
              size="s"
            >
              {{ item.email }}
            </base-text>
          </div>
          <div
            class="col-1 ml-auto text-right clickable underline"
            @click="viewDetails(item)"
          >
            <base-text
              size="md"
              class="mr-2"
            >
              {{ item.count }}
            </base-text>
          </div>
        </base-cell>
      </template>
    </base-list>
    <template v-slot:footer>
      <base-text
        size="s"
        class="text-center link"
      >
        <a @click="$emit('view-all')">View All</a>
      </base-text>
    </template>
  </base-widget>
</template>
<script>
export default {
  name: 'OutReachClientsWithMostOpens',
  props: {
    topOpens: {
      type: Array,
      default: () => ([]),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    goToClient(identifier) {
      this.$router.push(`/clients/${identifier}`);
    },
    viewDetails(customer) {
      this.$emit('view-details', customer);
    },
  },
};
</script>
<style scoped
  lang="scss">
a {
  cursor: pointer;
}

.link {
  cursor: pointer;
}

.horizontal-divider {
  border-bottom: 0.25px solid #333333cc;
}

.black {
  color: #333;
}

::v-deep .footer {
  margin-top: 20px;
}

.clickable {
  cursor: pointer;

  &.underline:hover {
    text-decoration: underline;
  }
}
</style>
